import React, { useEffect, useState } from "react";
import Head from "next/head";
import Navbar from "../components/_App/Navbar1";
import PageBanner from "../components/Common/PageBanner";
import Sidebar from "../components/TermsOfService/Sidebar";
import Footer from "../components/_App/Footer";
import styles from "./allPages.module.scss";

const ReturnRefund = ({ dataNav }) => {
  const [tabUrl, setTabUrl] = useState(null);
  const [title, setTitle] = useState("");
  const [images, setImages] = useState(null);
  useEffect(() => {
    setTabUrl(window.location.href);
    setTitle(document.title);
    setImages(document.images[0].src);
  }, []);

  return (
    <React.Fragment>
      <Navbar data={dataNav} />
      <PageBanner
        pageTitle="Return and Refunds"
        homePageUrl="/"
        homePageText="Home"
        activePageText="Return and Refunds"
      />

      <div>
        <Head>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
          ></link>
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content="Save your most valuable Time, and Money with expert-curated content and personalized learning."
          />
          <meta
            property="og:description"
            content="Save your most valuable Time, and Money with expert-curated content and personalized learning."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={tabUrl} />
          <meta property="og:image" content={images} />
          <link
            rel="canonical"
            // property="og:title"
            // content={title}
            // key="title"
            href={tabUrl}
          ></link>
        </Head>
      </div>

      <div className="privacy-policy-area ptb-100">
        <div className={styles["container"]}>
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div className={styles["privacy-policy-content"]}>
                <p>
                  We at Toppersnotes work hard to provide the best quality study
                  material.
                  <br />
                  Samples of each book are available on the product page with
                  detailed Index. If you face any issues with the study
                  material, please reach out to us within 5 days of receiving
                  the order.
                  <br /> <br />
                  We entertain a request for return & refund only for
                  below-mentioned cases:-
                  <br />
                  1. Product received is broken, damaged.
                  <br />
                  2. The product does not match the specification as per
                  specified during the placement of order.
                  <br />
                  In case of a return, shipping, marketing, operational and
                  damage deductions can be done before refund.
                  <br /> <br />
                  Order cancellation is valid until we dispatch the products
                  ordered. We do not entertain cancellation requests after the
                  product is being shipped or dispatched through our courier
                  partner.
                  <br /> <br />
                  <b> Digital Products: </b>
                  <br /> <br />
                  Strictly No Exchange
                  <br /> <br />
                  Strictly No Refund for Digital courses
                  <br /> <br />
                  Please Write a mail on Hello@toppersnotes.com with your order
                  ID and phone number.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-12">
              <Sidebar />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default ReturnRefund;
